"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useStyles = (0, _core.makeStyles)(function (theme) {
  return {
    section: {
      borderBottom: "2px dotted #606060",
      padding: "15px 5px",
      display: "block",
      background: "#f5f5f5",
      textAlign: "center"
    }
  };
});
/**
 * Section for a Card Component.
 */

function CardSection(props) {
  var children = props.children,
      style = props.style;
  var classes = useStyles();
  return _react.default.createElement("div", {
    className: classes.section + " story-card__section",
    style: style
  }, _react.default.createElement(_core.Typography, {
    variant: "caption"
  }, children));
}

CardSection.propTypes = {
  /** Styling object of the `Card` */
  style: _propTypes.default.object
};
CardSection.defaultProps = {};
var _default = CardSection;
exports.default = _default;